import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { SqlService } from "../../Database/sql.service";

import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import Swal from 'sweetalert2';


@Component({
  selector: 'app-admin-select-agent',
  templateUrl: './admin-select-agent.component.html',
  styleUrls: ['./admin-select-agent.component.css']
})
export class AdminSelectAgentComponent implements OnInit {


  AgentsData = [
    {
      Name: "Loading",
      Surname: "Loading",
      CellNo: "",
      ID: "",
      Code: ""
    }];
  Agent = 0;


  date = "";
  CurrentDate = "";


  BoxNumber = "";
  BrickNumber = "";

  closeResult = '';
  DisplayErrormessage = "";
  PopupTitle = "";

  firstscreen = true;
  Secondscreen = false;

  ConfirmReset = "";
  SelectedBoxNumbers = [""];
  PossibleBoxNumbers = [""];
  PossibleBox = "";

  SelectedBrickNumbers = [""];
  PossibleBrickNumbers = [""];
  PossibleBrick = "";



  forceClose = false;

  constructor(private dbService: SqlService, private modalService: NgbModal) { }

  ngOnInit(): void {

    let tempDate = new Date();
    this.CurrentDate = tempDate.getFullYear() + "-";
    let monthTemp = Number.parseInt(tempDate.getMonth().toString());
    monthTemp++;
    if (tempDate.getMonth().toString().length == 1) {
      this.CurrentDate += "0" + monthTemp + "-";
    } else {
      this.CurrentDate += monthTemp + "-";
    }

    if (tempDate.getDate().toString().length == 1) {
      this.CurrentDate += "0" + tempDate.getDate();
    } else {
      this.CurrentDate += tempDate.getDate();
    }


    this.SelectedBoxNumbers.pop();
    this.SelectedBrickNumbers.pop();
    this.GetAllAgents();
    this.GetAllBoxNames(" Direct='true' AND Agent IS NOT NULL");
    this.GetAllBrickNumbers(" Direct='true' AND Agent IS NOT NULL");
  }

  Province = "";
  Provinces = [""];
  Distributor = "";
  Distributors = [""];
  data = [
    {
      ID: "",
      Province: "",
      Active: ""

    }];



  async GetAllAgents() {
    await (this.dbService.getAllAgents().subscribe((ret: any) => {
      if (ret != "false") {
        this.AgentsData.splice(0);
        let a = (ret as string).split(';');
        a.splice(a.length - 1, 1);

        a.forEach(element => {
          let elementtemp = element.split(",")
          let temp = {
            Name: elementtemp[0],
            Surname: elementtemp[1],
            CellNo: elementtemp[2],
            ID: elementtemp[3],
            Code: elementtemp[4]
          }
          this.AgentsData.push(temp);
        });
      } else {
        alert("Please check your connection and try again");
      }
    }));
  }



  GetAllBrickNumbers(condition: string) {
    Swal.fire({
      title: 'Loading Bricks',
      showConfirmButton: false,
      toast: false,
      allowOutsideClick: false, 
      allowEscapeKey: false,
      willOpen: () => {
        Swal.showLoading();
      }
    });

    this.PossibleBrickNumbers.splice(0);

    let formData = new FormData(); // Currently empty
    formData.set("Where", condition);

    (this.dbService.getTopBrickesNames(formData).subscribe((ret: any) => {
      if (ret != "false") {
        (ret as string).split(';').forEach(element => {
          this.PossibleBrickNumbers.push(element.toString().trim());
        });

        Swal.close();
      } else {
        this.PopupTitle = "Error"
        this.DisplayErrormessage = "Please check your internet connection and try again";
        let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
        element.click();
        Swal.close();
      }
    }));
  }


  GetAllBoxNames(condition: string) {
    Swal.fire({
      title: 'Loading Boxes',
      showConfirmButton: false,
      toast: false,
      allowOutsideClick: false, 
      allowEscapeKey: false,
      willOpen: () => {
        Swal.showLoading();
      }
    });

    this.PossibleBoxNumbers.splice(0);

    let formData = new FormData(); // Currently empty
    formData.set("Where", condition);


    (this.dbService.getTopBoxesNamesForSelectingAgentScreen(formData).subscribe((ret: any) => {
      if (ret != "false") {

        (ret as string).split(';').forEach(element => {
          this.PossibleBoxNumbers.push(element.toString().trim());
        });

        Swal.close();
      } else {
        this.PopupTitle = "Error"
        this.DisplayErrormessage = "Please check your internet connection and try again";
        let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
        element.click();
        Swal.close();
      }
    }));
  }


  AddBox() {
    if (this.PossibleBoxNumbers.indexOf(this.BoxNumber) != -1) {
      if (this.SelectedBoxNumbers.indexOf(this.BoxNumber) == -1) {
        this.SelectedBoxNumbers.push(this.BoxNumber);
      }
    }
  }
  RemoveBox() {
    if (this.SelectedBoxNumbers.indexOf(this.BoxNumber) != -1) {
      this.SelectedBoxNumbers = this.SelectedBoxNumbers.filter(x => x !== this.BoxNumber);
    }
  }


  AddBrick() {
    if (this.PossibleBrickNumbers.indexOf(this.BrickNumber) != -1) {
      if (this.SelectedBrickNumbers.indexOf(this.BrickNumber) == -1) {
        this.SelectedBrickNumbers.push(this.BrickNumber);
      }
    }

  }
  RemoveBrick() {
    if (this.SelectedBrickNumbers.indexOf(this.BrickNumber) != -1) {
      this.SelectedBrickNumbers = this.SelectedBrickNumbers.filter(x => x !== this.BrickNumber);
    }
  }


  Reset() {
    this.Province = "";
    this.Distributor = "";
    this.Distributors.splice(0);
    this.BoxNumber = "";
    this.Agent = 0;
    this.SelectedBoxNumbers = [];
    this.SelectedBrickNumbers = [];
    this.BrickNumber = "";

    this.firstscreen = true;
    this.Secondscreen = false;

    this.GetAllBoxNames(" Direct='true' AND Agent IS NOT NULL");
    this.GetAllBrickNumbers(" Direct='true' AND Agent IS NOT NULL");
  }


  async Next() {

    Swal.fire({
      title: 'Allocating agent to box and bricks.',
      showConfirmButton: false,
      toast: false,
      allowOutsideClick: false, 
      allowEscapeKey: false,
      willOpen: () => {
        Swal.showLoading();
      }
    });


    if (this.SelectedBoxNumbers.length == 0 && this.SelectedBrickNumbers.length == 0) {
      this.PopupTitle = "Error"
      this.DisplayErrormessage = "Please Select atleast 1 brick or Box Number";
      let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
      element.click();
      Swal.close();
    } else {
      var formData = new FormData();

      var tempSql = "('";
      if (this.SelectedBoxNumbers.length == 0) {
        tempSql = "('')";
      } else {
        this.SelectedBoxNumbers.forEach(element => {
          tempSql += element + "','";
        });
        tempSql = tempSql.substring(0, tempSql.length - 2) + ")";
      }


      var tempSqlBrick = "('";
      if (this.SelectedBrickNumbers.length == 0) {
        tempSqlBrick = "('')";
      } else {
        this.SelectedBrickNumbers.forEach(element => {
          tempSqlBrick += element + "','";
        });
        tempSqlBrick = tempSqlBrick.substring(0, tempSqlBrick.length - 2) + ")";
      }

      formData.set("BoxNumbers", tempSql);
      formData.set("BrickNumbers", tempSqlBrick);
      formData.set("Agent", this.AgentsData[this.Agent].ID);
      formData.set("SelectedDate", this.date);



      await (this.dbService.SelectAgent(formData).subscribe((ret: any) => {
        if (!(String(ret).includes("Error"))) {

          this.PopupTitle = "Success"
          this.DisplayErrormessage = "The Agent has been selected";
          let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
          element.click();
          this.Reset();
          this.GetAllBoxNames(" Direct='true' AND Agent IS NOT NULL");
          Swal.close();
        } else {
          //"Error.Duplicate entry 'Box1-1' for key 'PRIMARY'"
          console.log(ret);
          if (String(ret).includes("Duplicate entry")) {
            let tepError = String(ret).replace("Error.", "");
            tepError = tepError.replace(" for key 'PRIMARY'", "") + "(Serial Number)";

            this.PopupTitle = "Invalid Details"
            this.DisplayErrormessage = tepError;
            let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
            element.click();
          } else {

            this.PopupTitle = "Error"
            this.DisplayErrormessage = "Please check your internet connection and try again";
            let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
            element.click();
            Swal.close();
          }
        }
      }));
    }
  }

  PossibleBoxChanged() {
    this.BoxNumber = this.PossibleBox[0];
  }

  PossibleBrickChanged() {
    this.BrickNumber = this.PossibleBrick[0];
  }

  BoxNameChanged() {
    this.GetAllBoxNames(" (Direct='true') AND (Agent IS NOT NULL) AND ([Pactel].[dbo].[BoxDetails].Boxno like '" + this.BoxNumber + "%') ");
  }

  BrickNumberChanged() {
    this.GetAllBrickNumbers(" (Direct='true') AND (Agent IS NOT NULL) AND ([Pactel].[dbo].[BoxDetails].[BrickNumber] like '" + this.BrickNumber + "%') ");
  }



  ForceClose() {

    this.ConfirmReset = "";
    this.PopupTitle = "Warning!"
    this.DisplayErrormessage = "Please type in 'DONE' below to FORCE close the box.";
    let element: HTMLButtonElement = document.getElementById('btnConfirmClose') as HTMLButtonElement;
    element.click();
  }


  open(content: any) {
    this.modalService.open(content,
      { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
        this.closeResult = 'Closed with: ${result}';
      }, (reason) => {
        this.closeResult =
          'Dismissed ${this.getDismissReason(reason)}';
        //let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
        //element.click();
      });
  }

  open2(content: any) {
    this.modalService.open(content,
      { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
        this.closeResult = 'Closed with: ${result}';
      }, (reason) => {
        this.closeResult =
          ' Dismissed ${this.getDismissReason(reason)}';
        let element: HTMLButtonElement = document.getElementById('ErrorButtonConstant') as HTMLButtonElement;
        element.click();
      });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return 'with: ${reason}';
    }
  }

}
